import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors, Container, InternalLink, AnimateIn, TitleSet, media } from '../../ui-components';
import renderRichText from '../../utils/render-rich-text';

const propTypes = {
  className: PropTypes.string,
  footerCta: PropTypes.object,
  pageGeo: PropTypes.string
};

/**
 * Renders a call-to-action section with a title and a button
 *
 * @component FooterCta 
 * 
 * @param {object} props
 * 
 * @prop {object} footerCta
 * @prop {string} pageGeo
 * 
 * @return {JSX}
 */
const FooterCTA = props => {
  const { footerCta, pageGeo } = props;
  const { title, body, primaryButtonText, primaryButtonUrl, secondaryButtonText, secondaryButtonUrl } = footerCta;

  const renderPrimaryButton = () => {
    return (
      <FooterButton linkstyle="primary-button" to={primaryButtonUrl}>
        {primaryButtonText}
      </FooterButton>
    )
  };

  const renderSecondaryButton = () => {
    return (
      <FooterButton linkstyle="secondary-button" to={secondaryButtonUrl}>
        {secondaryButtonText}
      </FooterButton>
    )
  };

  if (title && primaryButtonText && primaryButtonUrl) {
    return (
      <AnimateIn onScroll direction={'none'}>
        <TitleContainer full>
          {secondaryButtonText && secondaryButtonUrl ? (
            <>
              <TitleSet title={title} bodyText={renderRichText(body, pageGeo)} bodyTextSize={'medium'} />
              <ButtonContainer>
                {renderPrimaryButton()}
                {renderSecondaryButton()}
              </ButtonContainer>
            </>
          ) : (
            <>
              <TitleSet title={title} noMaxWidth />
              <ButtonContainer>
                {renderPrimaryButton()}
              </ButtonContainer>
            </>
          )}
        </TitleContainer>
      </AnimateIn>
    );
  }
};

const TitleContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 80px;
  background-color: ${colors.lightSky};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  gap: 24px;

  @media screen and (max-width: ${media.mediumBottom}) {
    align-items: center;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
  }
`;

const FooterButton = styled(InternalLink)`
  padding-bottom: 14px;
  width: fit-content;

  @media screen and (max-width: ${media.mediumBottom}) {
    align-items: center;
    flex-direction: column;
    width: 220px;
    gap: 16px;
  }
`;

FooterCTA.propTypes = propTypes;

export default FooterCTA;
